export enum EventName {
	LEGACY_EVENT = 'legacyEvent',
}
